import _ from 'lodash';

import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import { SERVICEMODALSTEP } from 'config/constants';
import { VirtualServiceOrder } from 'models';
import VirtualServiceExample from './VirtualServiceExample';
import VirtualServiceOption from './VirtualServiceOption';
import BlueHourReview from './BlueHourReview';
import VirtualServiceSummary from './VirtualServiceSummary';
import VirtualServiceReview from './VirtualServiceReview';

import useStyles from './styles';

interface Props {
  onClose: () => void;
}

function ModalStepper({ onClose }: Props) {
  const styles = useStyles();

  const initialStep = 0;
  const [activeStep, setActiveStep] = useState(initialStep);
  const [virtualServiceOrder, setOrder] = useState<VirtualServiceOrder>();
  const [selectedService, setSelectedService] = useState(null);
  const image = [];
  const [selectedImages, setSelectedImages] = useState(image);
  useEffect(() => {}, [selectedImages, setSelectedImages]);
  const stepContent = () => {
    switch (activeStep) {
      case SERVICEMODALSTEP.EXAMPLE:
        return (
          <VirtualServiceExample
            key={0}
            setActiveStep={setActiveStep}
            setOrder={setOrder}
            setSelectedImages={setSelectedImages}
            selectedService={selectedService}
            setSelectedService={setSelectedService}
          />
        );
      case SERVICEMODALSTEP.OPTION:
        return (
          <VirtualServiceOption
            key={1}
            setActiveStep={setActiveStep}
            virtualServiceOrder={virtualServiceOrder}
            selectedService={selectedService}
            setOrder={setOrder}
            selectedImages={selectedImages}
            setSelectedImages={setSelectedImages}
          />
        );
      case SERVICEMODALSTEP.REVIEW:
        return (
          <VirtualServiceReview
            key={2}
            setActiveStep={setActiveStep}
            selectedService={selectedService}
            virtualServiceOrder={virtualServiceOrder}
            selectedImages={selectedImages}
            setOrder={setOrder}
            setSelectedImages={setSelectedImages}
          />
        );
      case SERVICEMODALSTEP.BLUEHOUR:
        return (
          <BlueHourReview
            key={3}
            setActiveStep={setActiveStep}
            selectedService={selectedService}
            virtualServiceOrder={virtualServiceOrder}
            setOrder={setOrder}
            setSelectedImages={setSelectedImages}
          />
        );
      case SERVICEMODALSTEP.SUMMARY:
        return (
          <VirtualServiceSummary
            key={4}
            setActiveStep={setActiveStep}
            selectedService={selectedService}
            virtualServiceOrder={virtualServiceOrder}
          />
        );
      default:
        return (
          <VirtualServiceExample
            key={0}
            setActiveStep={setActiveStep}
            setOrder={setOrder}
            setSelectedImages={setSelectedImages}
            selectedService={selectedService}
            setSelectedService={setSelectedService}
          />
        );
    }
  };

  return (
    <Box className={styles.serviceModalStepper}>
      <Box className={styles.stepContent}>{stepContent()}</Box>
    </Box>
  );
}

ModalStepper.defaultProps = {
  onClose: _.noop,
};

ModalStepper.propTypes = {
  onClose: PropTypes.func,
};

export default ModalStepper;
